const ROUTES = {
  landing: '/',
  tutorAccountStatement: '/estado_cuenta_menores',
  tutorDatos: '/estado_cuenta_menores/datos',
  tutorOpciones: '/estado_cuenta_menores/opciones',
  tutorExito: '/estado_cuenta_menores/exito',
  pagos: '/pagos',
  pagoqr: '/pagoqr',
  registroqr: '/registroqr',
};

export default { ROUTES };